import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** RichTextEditor property - Definition */
export class DocsBlockRichTextEditorPropertyDefinition extends DocsBlockPropertyDefinition {
}
